<form [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'album_case.modal.form.album' | translate }}</mat-label>
    <mat-select formControlName="album">
      <mat-option *ngFor="let album of albums$ | async" [value]="album">{{ album.name }} ({{ album.clinicName }})</mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('album')?.invalid">{{ 'album_case.modal.form.album_required' | translate }}</mat-error>
  </mat-form-field>

  <mat-checkbox formControlName="anonymize">
    {{ 'album_case.modal.form.anonymise' | translate }}
  </mat-checkbox>

  <mat-checkbox formControlName="cloneAttachment" *ngIf="!isAtlas()">
    {{ 'album_case.modal.form.clone_attachment' | translate }}
  </mat-checkbox>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'album_case.modal.form.name' | translate }}</mat-label>
    <input matInput placeholder="" name="description" formControlName="name">
    <mat-error *ngIf="form.get('name')?.invalid">{{ 'album_case.modal.form.name_required' | translate }}</mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'album_case.modal.form.album_type' | translate }}</mat-label>
    <mat-select formControlName="type">
      <mat-option *ngFor="let type of albumCaseTypes" [value]="type">{{convertAlbumTypeEnum(type)}}</mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('type')?.invalid">{{ 'album_case.modal.form.album_type_required' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'album_case.modal.form.species' | translate }}</mat-label>
    <mat-select formControlName="species">
      <mat-option *ngFor="let species of speciesList" [value]="species">{{ 'species.' + species.name.toLowerCase() | translate}}</mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('species')?.invalid">{{ 'album_case.modal.form.species_required' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{'album_case.modal.form.sex' | translate }}</mat-label>
    <mat-select formControlName="sex" required>
      <mat-option *ngFor="let sex of sexes"
        [value]="sex">{{ 'enum.sex.' + SexEnum[sex].toString().toLowerCase()  | translate}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('sex')?.hasError('required')">{{'album_case.modal.form.sex_required' | translate}}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{'album_case.modal.form.sterilisation' | translate }}</mat-label>
    <mat-select formControlName="sterilisation" required>
      <mat-option *ngFor="let sterilisation of sterilisations"
        [value]="sterilisation">{{ 'enum.sterilisation.' + SterilisationEnum[sterilisation].toString().toLowerCase()  | translate}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('sterilisation')?.hasError('required')">{{'album_case.modal.form.sterilisation_required' | translate}}</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" *ngIf="showSerie">
    <mat-label>{{ 'album_case.modal.form.serie' | translate }}</mat-label>
    <mat-select formControlName="serie">
      <mat-option *ngFor="let serie of series$| async" [value]="serie">
        {{serie.modalityTypeDescription  + " - " + (serie.studyName ? serie.studyName : "id " + serie.id)}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <h3>{{ 'album_case.modal.form.instances' | translate:{nb: form.get('instances')?.value?.length ?? 0} }}</h3>
  <mat-selection-list formControlName="instances">
    <mat-list-option *ngFor="let instance of instances" [value]="instance.internalid">
      <img [src]="previewUrl + instance.publicid + '.png'" [alt]="instance.internalid" class="album-case-image" alt="Aperçu de l'étude">
    </mat-list-option>
  </mat-selection-list>
</form>
